import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionTargetsFetchListPayload,
	IActionTargetsFetchListPayloadDone,
	IActionTargetsFetchListPayloadError,
} from './types';

export const targetsFetchList = actionCreatorAsync<
	IActionTargetsFetchListPayload,
	IActionTargetsFetchListPayloadDone,
	IActionTargetsFetchListPayloadError
>(
	'targetsFetchList',
	async () => {
		const { data } = await Api.targets.fetchList();

		return data;
	},
);
